import { Component } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';
import { SimpleTable } from './simple-table';
import { SimpleTableColumnDef } from './simple-table-column-def';
import { SimpleTableHeaderCellDef } from './simple-table-header-cell-def';
import { SimpleTableCellDef } from './simple-table-cell-def';

/**
 * Placeholder for the Medical Notes widget in the form designer.
 */
@Component({
  selector: 'fb-medical-notes-widget-placeholder',
  imports: [
    SimpleTable,
    SimpleTableColumnDef,
    SimpleTableHeaderCellDef,
    SimpleTableCellDef,
    RxIconModule,
  ],
  templateUrl: './medical-notes-widget-placeholder.html',
  styleUrl: './medical-notes-widget-placeholder.scss',
})
export class MedicalNotesWidgetPlaceholder {}
